import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box,
} from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";

const ShopListByArea = () => {
  const { areaName } = useParams(); // e.g. "Wagholi"
  const [shops, setShops] = useState([]);

  useEffect(() => {
    console.log("AREA PARAM:", areaName);
    axios
      .get(`https://sakhisshop.com/api/shops/by-area/${areaName}`)
      .then((res) => {
        console.log("DATA:", res.data);
        setShops(res.data);
      })
      .catch((err) => console.error("Failed to fetch shops", err));
  }, [areaName]);

  return (
    <Container sx={{ mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        🛍 Shops delivering in {areaName}
      </Typography>

      <Grid container spacing={3}>
        {shops.length === 0 ? (
          <Typography variant="h6" color="error" sx={{ ml: 2 }}>
            No shops available in this area.
          </Typography>
        ) : (
          shops.map((shop, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardMedia component="img" height="180" alt={shop.shopname} />
                <CardContent>
                  <Typography variant="h6" textAlign="center" fontWeight={600}>
                    {shop.shopname}
                  </Typography>

                  <Typography
                    variant="body2"
                    textAlign="center"
                    color="text.secondary"
                  >
                    📍 Base Area: {shop.area}
                  </Typography>

                  {shop.serviceAreas && shop.serviceAreas.length > 0 && (
                    <Typography
                      variant="body2"
                      textAlign="center"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      🚚 Delivering To: {shop.serviceAreas.join(", ")}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
};

export default ShopListByArea;
